export default "__VITE_ASSET__2c15b659__"